import { Card, Divider, Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import FieldContainer from '../../../FormFields/FieldContainer';
import FormMoneyField from '../../../FormFields/FormMoneyField';
import FormTitle from '../../../FormFields/FormTitle';
import FormVendorField from '../../../FormFields/FormVendorField';
import { formCardStyle } from '../../../TransitionStyles';
import { FILE_TYPES } from '../../../formFileTypesEnum';
import { TELECOMMUNICATIONS } from '../../../formQuestionsEnum';

ITForm.propTypes = {
  permissions: PropTypes.object,
};

export default function ITForm({ permissions }) {
  const [focusedField, setFocusedField] = useState(null);

  const fieldIds = [TELECOMMUNICATIONS.IT_PROVIDER.id, TELECOMMUNICATIONS.IT_MONTHLY_COST.id];

  const showForm = fieldIds.some((id) => id in permissions);

  return (
    showForm && (
      <Card sx={formCardStyle}>
        <Typography sx={{ mb: 1 }} align="center" variant="body1" color="info.main">
          IT
        </Typography>
        <Divider sx={{ mb: 1, mt: 2, borderWidth: 1 }} />
        <Grid container spacing={1.5}>
          {TELECOMMUNICATIONS.IT_PROVIDER.id in permissions && (
            <Grid item xs={12}>
              <FieldContainer>
                <FormTitle fieldAttributes={{ questionTitle: 'IT provider', fieldType: 'title' }} />
                <FormVendorField
                  fieldName={TELECOMMUNICATIONS.IT_PROVIDER.fieldName}
                  fieldAttributes={{ isEditable: permissions[TELECOMMUNICATIONS.IT_PROVIDER.id] }}
                  invoiceFileTypeId={FILE_TYPES.IT_PROVIDER_INVOICE}
                  contractFileTypeId={FILE_TYPES.IT_PROVIDER_CONTRACT}
                />
              </FieldContainer>
            </Grid>
          )}
          {TELECOMMUNICATIONS.IT_MONTHLY_COST.id in permissions && (
            <Grid item xs={12}>
              <FormTitle fieldAttributes={{ questionTitle: 'Current monthly cost' }} />
              <FormMoneyField
                fieldName={TELECOMMUNICATIONS.IT_MONTHLY_COST.fieldName}
                fieldAttributes={{
                  isEditable: permissions[TELECOMMUNICATIONS.IT_MONTHLY_COST.id],
                }}
                focusedField={focusedField}
                setFocusedField={setFocusedField}
              />
            </Grid>
          )}
        </Grid>
      </Card>
    )
  );
}
